<template>
  <div :class="isLargeScreen ? 'desktop' : 'mobile'">
    <div class="header">
      <Header v-if="isLargeScreen" />
      <DashboardTopMenu v-else />
    </div>

    <div class="sidebar">
      <CustomPanelMenu v-if="isLargeScreen" :userType="tipoUsuario" />
    </div>

    <div class="content">
      <div class="flex justify-content-start align-items-center">
        <CustomBreadcrumb v-if="shouldShowBreadcrumb" />
        <template v-else>
          <CustomButton
            v-if="shouldShowBackButton"
            icon="pi pi-arrow-left"
            buttonColor="#2196f3"
            tooltipText="Regresar"
            @click="goBack()"
          />
          <h2 class="currentTitle primaryFont" v-if="currentTitle">{{ currentTitle }}</h2>
        </template>
      </div>
      <router-view :key="$route.fullPath" />
    </div>

    <div class="footer" :class="isCalabozo ? 'footer-calabozo' : ''">
      <img
        alt="Logo de la Policia de San Juan"
        :src="`${$frontendOrigin}/assets/logo-policia-de-san-juan.png`"
        class="logo-policia"
      />
      <img
        alt="Logo Gobierno"
        :src="`${$frontendOrigin}/assets/seguridad.png`"
        class="logo-gobierno"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import Header from "./Dashboard/Header.vue";
import CustomPanelMenu from "./Dashboard/CustomPanelMenu.vue";
import DashboardTopMenu from "./Dashboard/DashboardTopMenu.vue";
import { getPageName } from "../utils/getPageName";
import { useStoreCompat, useRouterCompat, useBackButton, useBreadcrumb } from "@/composables";
import CustomButton from "@/components/custom-button/CustomButton.vue";
import CustomBreadcrumb from "@/components/custom-breadcrumb/CustomBreadcrumb.vue";

const store = useStoreCompat();
const { router } = useRouterCompat();
const { shouldShowBackButton, goBack } = useBackButton();
const { shouldShowBreadcrumb } = useBreadcrumb();
const isLargeScreen = ref(false);

const user = computed(() => store.state.user);
const tipoUsuario = computed(() => user.value.userdata.tipoUsuario);

function checkScreenSize() {
  isLargeScreen.value = window.matchMedia("(min-width: 1280px)").matches;
}

onMounted(() => {
  checkScreenSize();
  window.addEventListener("resize", checkScreenSize);

  router.afterEach((to) => {
    isCalabozo.value = to.path.includes("/calabozo");
  });
});

onUnmounted(() => {
  window.removeEventListener("resize", checkScreenSize);
});

const actuacionType = computed(() => {
  const sumario = store.state.sumario;
  const type = sumario?.formType;
  return type ? type.toUpperCase() : null;
});

const currentTitle = computed(() => {
  return getPageName(router, actuacionType);
});

const isCalabozo = ref(router.currentRoute.path.includes("/calabozo"));
</script>

<style scoped>
:global(html, body) {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

.mobile {
  margin: 0;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 3.5em auto auto;
  grid-template-areas:
    "header"
    "content"
    "footer";
}

.header {
  grid-area: header;
  width: 100%;
  padding: 8px 20px 0 20px;
  background: #fff;
}

.sidebar {
  display: none;
}

.content {
  grid-area: content;
  padding: 20px;
}

.footer {
  grid-area: footer;
  display: flex;
  align-self: flex-end;
  padding: 10px 0;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  margin: 0;
  position: sticky;
  background: #fff;
  bottom: 0;
  width: 99.6%;
  margin-left: 7px;
  z-index: 1000;
}

.footer-calabozo {
  z-index: 1 !important;
}

.footer > img {
  margin-bottom: 5px;
}
.footer .logo-policia {
  margin-right: 1.5em;
  height: 60px;
}
.footer .logo-gobierno {
  margin-left: 1.5em;
  height: 49px;
}

@media (min-width: 1280px) {
  .desktop {
    margin: 0;
    display: grid;
    grid-template-columns: 250px calc(100% - 250px);
    grid-template-rows: 3.5em 1fr auto;
    grid-template-areas:
      "header header"
      "sidebar content"
      "sidebar footer";
    height: 100vh;
  }

  .header {
    padding: 5px 20px 0 20px;
    position: fixed;
    z-index: 10;
  }

  .sidebar {
    grid-area: sidebar;
    background-color: #0b5195;
    padding: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    position: fixed;
    width: 255px;
  }
}

@media (min-width: 1280px) and (max-width: 1350px) {
  .content {
    padding: 20px 10px;
  }
  .currentTitle {
    padding: 0 20px;
  }
}

.currentTitle {
  font-size: 32px;
  color: black;
  font-weight: 700;
  line-height: 32px;
}
</style>
